export class LoadSubscriptionsStatsAction {
  static readonly type = '[Subscriptions Stats] Load Subscriptions Stats';

  constructor() { }
}